import { PauseCircle } from "lucide-react";

/**
 * Loja com o botão "aberta/fechada" do painel DESLIGADO (stores.is_active).
 *
 * É diferente de "fora do horário" (ver ClosedStoreCard): aqui o servidor
 * RECUSA o pedido de qualquer jeito. Antes de 18/09/2026 o cardápio não
 * sabia disso — o cliente montava o carrinho, digitava o endereço e só
 * levava o não no último clique (relato Dubom Burguer: a cliente desistiu do
 * site e mandou o pedido por WhatsApp, que não entra no painel).
 */
export function StoreInactiveCard({ className = "" }: { className?: string }) {
  return (
    <div
      className={`rounded-xl border border-orange-200 bg-orange-50 p-3 dark:bg-orange-950/20 dark:border-orange-800 ${className}`}
      data-testid="store-inactive-card"
    >
      <div className="flex items-start gap-2">
        <PauseCircle className="w-4 h-4 shrink-0 mt-0.5 text-orange-600 dark:text-orange-400" />
        <div className="min-w-0">
          <p className="text-sm font-semibold text-orange-900 dark:text-orange-200">
            Pedidos pausados
          </p>
          <p className="text-xs leading-relaxed text-orange-800 dark:text-orange-300">
            A loja não está recebendo pedidos agora. Dá pra ver o cardápio, mas o envio só volta quando ela reabrir.
          </p>
        </div>
      </div>
    </div>
  );
}
